import { createApi } from "@reduxjs/toolkit/query/react";
import { DateRange } from "rsuite/esm/DateRangePicker";
import { IApiResponse, IPaginate } from "../../../interfaces/common";
import { IReport, ReportModules } from "../../../interfaces/reports";
import { baseQuery } from "../common";
import moment from "moment";

export const reportApi = createApi({
  reducerPath: "reports",
  baseQuery: baseQuery,
  tagTypes: ["Reports", "Report"],
  refetchOnReconnect: false,
  endpoints: (builder) => ({
    getReportRefactored: builder.query<
      IApiResponse<IPaginate<ReportModules[]>>,
      {
        pagination: { page: number; limit: number };
        reportType?: string;
        start?: string;
        end?: string;
        departmentId?: string;
      }
    >({
      query: ({ pagination: { page = 1, limit = 10 }, reportType, start, end, departmentId }) =>
        `report/${reportType}/${start}/${end}?departmentId=${departmentId}&page=${page}&limit=${limit}`,
      providesTags: [{ type: "Reports", id: "LIST" }],
    }),

    getAllReportRefactored: builder.query<
      IApiResponse<IPaginate<ReportModules[]>>,
      {
        pagination: { page: number; limit: number };
        reportType?: string;
        departmentId?: string;
        start?: string;
        end?: string;
      }
    >({
      query: ({ reportType, departmentId, start, end }) =>
        `report/${reportType}/${start}/${end}?departmentId=${departmentId}&page=1&limit=1000`,
      providesTags: [{ type: "Reports", id: "LIST" }],
    })
  }),
});

export const {
  // useGetReportQuery,
  // useGetReportAllQuery,
  useGetReportRefactoredQuery,
  useGetAllReportRefactoredQuery,
} = reportApi;

